import React, { useState } from 'react';
import { FilterContainer, FormContainer } from './styles';
import {
  CustomersState,
  ICustomer
} from '../../../store/ducks/customers/types';
import { useDispatch } from 'react-redux';
import { loadCustomerFromId } from '../../../store/ducks/customers/actions';
import { Title } from '@gerdau/hefesto/Title';
import { TextField } from '@gerdau/hefesto/TextField';
import { Icon } from '@gerdau/hefesto/Icon';
import { Button } from '@gerdau/hefesto/Button';
import { Skeleton } from '@gerdau/hefesto/Skeleton';
import { sendTagging } from '../../../store/ducks/tagging/actions';

interface ICustomersFilter {
  customersState: CustomersState;
  customers: ICustomer[];
  onFilter(filteredCustomers: ICustomer[]): void;
  isManager: boolean;
}

const CustomersFilter: React.FC<ICustomersFilter> = ({
  customersState,
  customers,
  onFilter,
  isManager
}) => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState('');

  // useEffect(() => {
  //   if (
  //     isManager &&
  //     customers.length === 0 &&
  //     !customersState.loadingCustomerById &&
  //     !customersState.errorBp
  //   ) {
  //     dispatch(loadCustomerFromId('0100242468'));
  //   }
  // });

  const onClickSearch = () => {
    if (
      isManager &&
      searchValue.length > 5 &&
      !customers.find((cust) => cust.customerId === searchValue)
    ) {
      if (searchValue.length < 10) {
        dispatch(loadCustomerFromId(`0${searchValue}`));
      } else {
        dispatch(loadCustomerFromId(searchValue));
      }
    }
  };

  const onChangeValue = (value: string) => {
    setSearchValue(value);
    if (!isManager) {
      const filteredCustomers =
        value !== ''
          ? customers.filter(
              (customer) =>
                customer.name.toLowerCase().includes(value.toLowerCase()) ||
                customer.customerId.includes(value) ||
                (customer.taxNumber &&
                  customer.taxNumber
                    .toUpperCase()
                    .includes(value.toUpperCase()))
            )
          : customers;

      onFilter(filteredCustomers);
    }
  };

  const onPasteValue = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    onChangeValue(e.clipboardData.getData('text'));
  };

  const clearValue = () => {
    onChangeValue('');
    dispatch(
      sendTagging({
        screenName: 'LG:GestaoDeUsuarios',
        itemName: 'button:limpar_filtros',
        itemDescription: 'gestaoDeUsuarios_limparFiltros',
        event: 'click'
      })
    );
  };

  return (
    <>
      <FilterContainer>
        <Title level={3}>Filtros</Title>
        <FormContainer>
          <div className="input-wrapper">
            {customersState.loadingCustomerById || customersState.loading ? (
              <Skeleton type="input" />
            ) : (
              <TextField
                label={'Pesquisar'}
                placeholder={
                  isManager
                    ? 'Buscar por Nº do cliente'
                    : 'Filtrar por Razão social, CNPJ ou Nº do cliente'
                }
                name={'Search'}
                value={searchValue}
                onChange={(e) => onChangeValue(e.target.value)}
                onBlur={onClickSearch}
                onPaste={(e) => onPasteValue(e)}
                icon={<Icon option={'Search'} />}
                iconPosition="left"
                type="search"
                supportMessage={
                  customersState.errorBp && !customersState.loadingCustomerById
                    ? 'BP não encontrado'
                    : ''
                }
                disabled={
                  customersState.loadingCustomerById || customersState.loading
                }
              />
            )}
          </div>
          <Button
            loading={
              customersState.loadingCustomerById || customersState.loading
            }
            onClick={() => {
              clearValue();
            }}
            disabled={
              customersState.loadingCustomerById ||
              customersState.loading ||
              !searchValue
            }
            name={'cleanFilter'}
            fullWidth
            variant="secondary"
          >
            Limpar filtro
          </Button>
        </FormContainer>
      </FilterContainer>
    </>
  );
};

export default CustomersFilter;
